module.exports = __webpack_public_path__ + "static/img/jt_qrcode.8753b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jt_qrcode.png
// module id = 9sNZ
// module chunks = 48